import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2298791b")

_pushScopeId("data-v-2298791b")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Add Distributor Setting")
const _hoisted_2 = {
  class: "container",
  style: {"width":"600px","margin-top":"20px"}
}
const _hoisted_3 = { class: "columns is-align-items-start" }
const _hoisted_4 = { class: "is-half" }
const _hoisted_5 = { class: "buttons is-right buttons-section" }
const _hoisted_6 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  class: "button is-success"
}, "Save", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_drop_down_list = _resolveComponent("drop-down-list")
  const _component_field_validate = _resolveComponent("field-validate")
  const _component_loading_wrapper = _resolveComponent("loading-wrapper")
  const _component_numeric_text_box = _resolveComponent("numeric-text-box")
  const _component_modal_card = _resolveComponent("modal-card")

  return (_openBlock(), _createBlock(_component_modal_card, { active: _ctx.isVisible }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("form", {
          id: _ctx.formId,
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSaveClick && _ctx.onSaveClick(...args)), ["prevent"])),
          novalidate: ""
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_loading_wrapper, { isLoading: _ctx.isLoading }, {
              default: _withId(() => [
                _createVNode(_component_drop_down_list, {
                  label: 'Distributor',
                  style: { width: '100%' },
                  textField: 'name',
                  "data-items": _ctx.filteredDistributors,
                  required: true,
                  className: 'is-half',
                  filterable: true,
                  onFilterchange: _ctx.onFilterChange,
                  onChange: _ctx.onDropdownChange,
                  "validity-styles": false,
                  id: "distributor"
                }, null, 8, ["data-items", "onFilterchange", "onChange"]),
                _createVNode(_component_field_validate, {
                  required: "",
                  for: "distributor"
                })
              ]),
              _: 1
            }, 8, ["isLoading"]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_numeric_text_box, {
                style: { width: '100%' },
                label: 'Design Registration Minimum Revenue',
                placeholder: 'Design Registration Minimum',
                spinners: false,
                min: 1,
                step: 1,
                modelValue: _ctx.registrationRevenueMinimum,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.registrationRevenueMinimum = $event)),
                "validity-styles": false,
                format: _ctx.revenueFormat,
                id: "registrationRevenueMinimum"
              }, null, 8, ["modelValue", "format"]),
              _createVNode(_component_field_validate, {
                "min-value": 1,
                required: "",
                for: "registrationRevenueMinimum",
                "validation-model": _ctx.registrationRevenueMinimum
              }, null, 8, ["validation-model"])
            ])
          ]),
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "button is-link is-light",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCloseClick && _ctx.onCloseClick(...args)))
            }, "Close")
          ])
        ], 40, ["id"])
      ])
    ]),
    foot: _withId(() => [
      _hoisted_7
    ]),
    _: 1
  }, 8, ["active"]))
})